import { Sparkles } from "lucide-react";

const FEATURES = [
  "Curated homestay partners",
  "Estate-to-table cuisine",
  "Guided treks & waterfalls",
  "Bonfire evenings",
  "Coffee plantation walks",
];

/**
 * FeatureMarquee — forest-green ribbon between Hero and About. Auto-scrolls
 * horizontally, pauses on hover. Sits seamlessly against Hero's forest-green
 * bottom-fade so the two sections read as one continuous page.
 */
export default function FeatureMarquee() {
  // duplicate list once so the -50% translate loops seamlessly
  const items = [...FEATURES, ...FEATURES];

  return (
    <section
      aria-label="Peak Adventures Malnad — signature experiences"
      className="relative w-full bg-[var(--pam-forest)] text-white"
      style={{ padding: "5% 0" }}
      data-testid="feature-marquee-section"
    >
      <div className="pam-marquee-wrap" data-testid="feature-marquee">
        <div className="pam-marquee-track py-2">
          {items.map((label, i) => (
            <span
              key={`${label}-${i}`}
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-[var(--pam-gold)]/40 text-[var(--pam-gold)] bg-white/[0.02] backdrop-blur-sm text-sm md:text-base font-medium tracking-wide"
              data-testid={`feature-pill-${i}`}
            >
              <Sparkles className="w-3.5 h-3.5" />
              {label}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
